import api from '@/services/Api';
import router from '@/router/index';

// ----------------------------- o

const namespaced = false;

// ----------------------------- o

const state = {
    token: localStorage.getItem('access_token') ? localStorage.getItem('access_token') : '',
    deviceToken: localStorage.getItem('device_token') ? localStorage.getItem('device_token') : null,
    errors: {},
    loading: false
};

// ----------------------------- o

const getters = {
    isAuthenticated: state => !!state.token,
};

// ----------------------------- o

const actions = {

    /*
        All users
     */

    'AUTH_SAVE_DEVICE_TOKEN': ({commit, dispatch}, token) => {
        commit('AUTH_SAVE_DEVICE_TOKEN', token);
        localStorage.setItem('device_token', token); // set local storage
        console.log('AUTH_SAVE_DEVICE_TOKEN', token)
    },
    'AUTH_LOGIN_REQUEST': ({commit, dispatch}, user) => {
        return new Promise((resolve, reject) => {
            commit('AUTH_LOGIN_REQUEST');
            api({url: '/login', data: user, method: 'POST'})
                .then(resp => {
                    let token = 'Bearer '+resp.data.data.access_token
                    commit('AUTH_LOGIN_SUCCESS', token);
                    // set local storage
                    localStorage.setItem('access_token', token);
                    // set api headers
                    api.defaults.headers['Authorization'] = token;
                    // get user profile
                    dispatch('profile/PROFILE_REQUEST').then(() => {
                        // resolve login request only if profile resolves too!
                        resolve(resp)
                    });
            })
            .catch(err => {
                commit('AUTH_LOGIN_ERROR', err.response.data.errors || err.response.data);
                dispatch('GLOBAL_REMOVE_USER');
                reject(err)
            })
        })
    },
    'AUTH_LOGOUT_REQUEST': ({commit, dispatch, state}) => {
        return new Promise((resolve, reject) => {
            commit('AUTH_LOGOUT_REQUEST');
            let params = state.deviceToken ? {'deviceToken' : state.deviceToken } : null
            api({url: '/logout', params: params ? params : null, method: 'GET'})
            // do not wait for success,
            // logout immediately!
            // token can be obselete already!
            // you will receive 401 error
            commit('AUTH_REMOVE_TOKEN');
            dispatch('GLOBAL_REMOVE_USER');
            resolve()
        })
    },

    /*
     ASM specific
    */

    'AUTH_ASM_FIRST_LOGIN_REQUEST': ({commit, dispatch}, form) => {
        return new Promise((resolve, reject) => {
            commit('AUTH_LOGIN_REQUEST');
            api({url: '/asm/relogin', data: form, method: 'POST'})
                .then(resp => {
                    let token = 'Bearer '+resp.data.data.access_token
                    commit('AUTH_ASM_FIRST_LOGIN_SUCCESS', token);
                    // set local storage
                    localStorage.setItem('access_token', token);
                    // set api headers
                    api.defaults.headers['Authorization'] = token;
                    // get user profile
                    dispatch('profile/PROFILE_REQUEST').then(() => {
                        // resolve login request only if profile resolves too!
                        resolve(resp)
                    });
                })
                .catch(err => {
                    commit('AUTH_LOGIN_ERROR', err.response.data.errors || err.response.data);
                    reject(err)
                })
        })
    },

};

// ----------------------------- o

const mutations = {
    'AUTH_SAVE_DEVICE_TOKEN': (state, payload) => {
        state.deviceToken = payload;
    },
    // LOGIN
    'AUTH_LOGIN_REQUEST': (state) => {
        state.errors = {};
        state.loading = true
    },
    'AUTH_LOGIN_SUCCESS': (state, resp) => {
        state.token = resp;
        state.loading = false
    },
    'AUTH_LOGIN_ERROR': (state, resp) => {
        state.errors = resp;
        state.loading = false
    },
    // LOGOUT
    'AUTH_LOGOUT_REQUEST': (state) => {
        state.errors = {};
        state.loading = true
    },
    'AUTH_REMOVE_TOKEN': (state) => {
        state.token = ''
        state.loading = false
    },
    // ASM
    'AUTH_ASM_FIRST_LOGIN_SUCCESS': (state, resp) => {
        state.token = resp;
        state.loading = false
    }
};

// ----------------------------- o

export default {
    namespaced,
    state,
    getters,
    actions,
    mutations,
}
